/* Vaultiqe unified reveal — pairs with reveal.css
   ───────────────────────────────────────────────
   One IntersectionObserver instance for every [data-reveal] on the page.
   Sections opt in by tagging elements with the attribute. Per-element
   delay via data-reveal-delay="N" (ms). Triggers once, then unobserves. */

(function () {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  /* Design mode: editor re-renders sections out-of-band. CSS already keeps
     everything visible (.shopify-design-mode override); skip IO entirely so
     no class-toggling races with the editor. */
  if (window.Shopify && window.Shopify.designMode) return;

  var supportsIO = 'IntersectionObserver' in window;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var io = supportsIO && !reduceMotion
    ? new IntersectionObserver(onIntersect, {
        /* Fires early: the bottom margin EXPANDS the root instead of shrinking
           it, so an element starts fading while it is still ~12% of a viewport
           below the fold and is fully settled by the time it is properly in
           view. Threshold is deliberately near zero — a tall block should start
           on its first pixel, not after pushing 15% of its height in.
           Was 0.15 / -10% (late, and visibly so), then 0.06 / +6%. */
        threshold: 0.03,
        rootMargin: '0px 0px 12% 0px'
      })
    : null;

  function onIntersect(entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      var delay = parseInt(el.getAttribute('data-reveal-delay') || '0', 10);
      if (delay > 0) {
        setTimeout(function () { el.classList.add('is-revealed'); }, delay);
      } else {
        el.classList.add('is-revealed');
      }
      io.unobserve(el);
    });
  }

  function observe(root) {
    var els = (root || document).querySelectorAll('[data-reveal]:not(.is-revealed)');
    if (!els.length) return;
    if (!io) {
      els.forEach(function (el) { el.classList.add('is-revealed'); });
      return;
    }
    els.forEach(function (el) { io.observe(el); });
  }

  function init() { observe(document); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
